import React, { useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Typography,
  Paper,
  Divider,
} from "@material-ui/core";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import addVendor from "../../../../assets/images/Add User-rafiki.svg";
import { useStyles } from "./styles";
import { useUserContext } from "../../../../context/UserContext";

export default function AddSeller() {
  // const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const classes = useStyles();
  const { store } = useUserContext();
  const token = store.data.token;

  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const initialValues = {
    name: "",
    CNIC: "",
    email: "",
    address: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    city: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    email: Yup.string().email("Please enter email").required("Required*"),
    address: Yup.string().required("Required*"),
    CNIC: Yup.string().max(15).required("Please enter CNIC"),
    password: Yup.string().required("Please Enter Your Type Of Business!"),
    city: Yup.string().required("Please Enter The Name!!"),
    phoneNumber: Yup.string().required("Please Enter the Contact Number!"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Passwords Must Match To Continue"
    ),
  });

  const onSubmit = (values, props) => {
    console.log("Values are ", values);
    const { name, email, address, CNIC, password, city, phoneNumber } = values;
    api
      .post(
        "/superAdmin/seller/register",
        {
          name,
          email,
          address,
          CNIC,
          password,
          city,
          phoneNumber,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(function (res) {
        console.log(res);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Seller Has Been Added Sucessfully.",
          open: true,
        });
        // setTimeout(() => setIsRegistered(true), [2000]);
        // return registerUser(
        //   dispatch,
        //   res.data.data.seller,
        //   res.data.data.token
        // );
      })
      .catch((error) => {
        // message: JSON.stringify(error.response.data.error),
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: JSON.stringify(error.response.data.error),
          open: true,
        });
      });
  };

  return (
    <Grid container component={Paper}>
      <Grid item xs={12} sm={12} md={12}>
        <div className={classes.paper}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Typography variant="h4" gutterBottom>
                Add Seller Details
              </Typography>
              <Divider />
              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => (
                  <Form className={classes.form}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          margin="dense"
                          variant="outlined"
                          required
                          fullWidth
                          label="Name"
                          name="name"
                          helperText={<ErrorMessage name="name" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          margin="dense"
                          variant="outlined"
                          required
                          fullWidth
                          label="Email"
                          name="email"
                          helperText={<ErrorMessage name="email" />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          name="CNIC"
                          label="CNIC"
                          helperText={<ErrorMessage name="CNIC" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Contact Number"
                          name="phoneNumber"
                          helperText={<ErrorMessage name="phoneNumber" />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          type="password"
                          errors
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Password"
                          name="password"
                          helperText={<ErrorMessage name="password" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          type="password"
                          errors
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Password"
                          name="confirmPassword"
                          helperText={<ErrorMessage name="confirmPassword" />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="City"
                          name="city"
                          helperText={<ErrorMessage name="city" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Address"
                          name="address"
                          helperText={<ErrorMessage name="address" />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                        <Button
                          type="submit"
                          size="large"
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                        >
                          Add Seller
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
            <Grid item xs={false} sm={false} md={false} lg={4}>
              <div
                style={{
                  border: "1px solid rgb(224 224 224)",
                  borderRadius: 6,
                  padding: 15,
                  marginTop: 35,
                }}
              >
                <img
                  src={addVendor}
                  alt="vendor"
                  style={{
                    maxWidth: "300px",
                    marginBottom: 20,
                  }}
                />
                <Typography variant="h5">DO YOU KNOW?</Typography>
                <Typography variant="body2" style={{ textAlign: "justify" }}>
                  In order to make more sales, Write an eye-catching and short
                  name for Vendor and upload its high-quality images.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>
    </Grid>
  );
}
